import { render, staticRenderFns } from "./ProgrammaticDataList.vue?vue&type=template&id=7a07d77d&"
import script from "./ProgrammaticDataList.vue?vue&type=script&lang=ts&"
export * from "./ProgrammaticDataList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports